module.exports = __webpack_public_path__ + "static/media/16UNODC27.4a135f32.jpg";